import type { PropsWithChildren, ReactNode } from "react";

import { cn } from "@krea/shared/utils";

interface DetailsContainerProps {
  className?: string;
  title?: string | ReactNode;
  background?: boolean;
  status?: string | ReactNode;
}

const DetailsContainer = ({
  className,
  title,
  children,
  background,
  status,
}: PropsWithChildren<DetailsContainerProps>) => {
  return (
    <section className={cn(" mb-7", className)}>
      {title && (
        <div className="mb-5 flex flex-wrap items-center justify-between">
          {title && (
            <h1 className=" mb-0 pr-4 text-[1.5rem]">{title}</h1>
          )}
          {status && <span>{status}</span>}
        </div>
      )}
      <div
        className={cn({
          "bg-white shadow-sm p-4": background,
        })}
      >
        {children}
      </div>
    </section>
  );
};

export default DetailsContainer;
